import {WebForm} from "../public.core";
import {WebFormStackVariableFieldsObject} from "../devbx.webform.mslang";

export function createWebFormApp(data) {

    function prepareFormFields(fields)
    {
        fields.forEach(field => {

            if (field.type === 'object')
            {
                prepareFormFields(field.value);
            } else {
                field.changed = false;
            }
        });
    }

    let app = BX.Vue3.BitrixVue.createApp({
        data() {
            prepareFormFields(data.webForm.formFields);

            return {
                admin: data.admin,
                debug: true,
                sid: data.sid,
                webForm: new WebForm(data.webForm.config),
                formClass: !!data.formClass ? data.formClass : '',
                formElements: data.webForm.formElements,
                formFields: data.webForm.formFields,
                formReadonly: false,
                culture: data.culture,
                activePageId: false,
                activeId: false,
                visiblePages: [],
                beforeTransitionCheckErrors: false,
                pageChange: false,
                submitAjax: false,
                validation: true,
                mode: 'init',
                errors: [],
                popupMessages: [],
            };
        },
        mounted() {
            //let time = (new Date()).getTime();

            let items = Object.values(this.pages);

            if (items.length) {
                this.visiblePages.push(items[0]);
                this.activePageId = items[0].id;
            }

            this.mode = 'pages';

            /*
            if (this.debug)
            {
                console.log('init time ',(new Date()).getTime()-time);
            }*/
        },
        methods: {
            formatString(str, search, replace) {
                if (typeof str === 'undefined')
                    return '';

                if (typeof str !== 'string')
                    str = str.toString();

                if (!Array.isArray(search)) {
                    search = [search];
                    replace = [replace];
                }

                search.forEach((s, i) => {
                    str = str.replaceAll(s, replace[i]);
                });

                return str;
            },

            getConditionVariables() {
                let result = {};

                result['Fields'] = new WebFormStackVariableFieldsObject(this.formFields);

                return result;
            },

            executeScriptCode(cond)
            {
                cond.error = false;

                if (!cond.code)
                    return false;

                if (!cond.context) {
                    let nodeList = [];

                    try {
                        const lexer = new DevBX.MSLang.CodeLexer(cond.code);
                        const parser = new DevBX.MSLang.CodeParser(lexer);

                        parser.parseCode(nodeList, true, true, DevBX.MSLang.LexerTypeArray.one(DevBX.MSLang.LexerType.ltEof));
                    } catch (e) {
                        cond.error = true;
                        cond.message = e.message;
                        return false;
                    }

                    const interpreter = new DevBX.MSLang.Interpreter();
                    interpreter.registerHandlers();

                    cond.context = new DevBX.MSLang.ContextInterpreter(nodeList, interpreter);
                }

                try {

                    cond.context.reset();

                    cond.context.registerConst();
                    cond.context.setVariable('DateTime', new DevBX.MSLang.StackVariableDateTimeObject());

                    let conditionVariables = this.getConditionVariables();

                    Object.keys(conditionVariables).forEach(key => {
                        cond.context.setVariable(key, conditionVariables[key]);
                    });

                    cond.returnVal = cond.context.exec(true);

                    if (!cond.returnVal)
                        return false;

                    if (cond.returnVal.value === undefined) {
                        cond.error = 'return undefined value';

                        return false;
                    }
                    return true;
                } catch (e) {
                    cond.error = 'failed execute code: '+e.message;
                    return false;
                }
            },

            checkCondition(objCondition, props, fieldName) {
                if (props === undefined)
                    debugger;

                let cond = props[fieldName];

                switch (cond.value) {
                    case 'always':
                        return true;
                    case 'never':
                        return false;
                    case 'when':
                        break;
                    default:
                        return null;
                }

                if (!this.executeScriptCode(cond)) {
                    if (cond.error)
                    {
                        console.error('execute condition error, '+cond.error, objCondition, props, fieldName);
                    }

                    return null;
                }

                return !!cond.returnVal.value;
            },

            getComponentsByName(name, childItems) {
                if (typeof childItems === "undefined")
                    childItems = this.$children;

                let component;

                if (name !== false)
                {
                    component = this.$.appContext.components[name];
                    if (!component) {
                        console.error('Unknown component: ' + name);
                        return;
                    }
                }

                let result = [];

                childItems.forEach(item => {
                    if (name === false || item.$.type === component) {
                        result.push(item);
                    }

                    result.push(...this.getComponentsByName(name, item.$children));
                });

                return result;
            },

            getFormElementById(id) {

                let result = false;

                this.formElements.forEach(group => {

                    group.items.forEach(item => {

                        if (item.data.fieldId === id) {
                            result = item;
                            return false;
                        }

                        return true;
                    });

                    return result === false;

                });

                return result;
            },

            htmlFormatFields(html) {
                if (!html)
                    return '';

                let fields = this.formFieldByName,
                    self = this;

                html = html.replace(/#([a-zA-Z0-9_\.]+)#/g, function (str, ind) {
                    let field = fields[ind];

                    if (!field) {
                        if (self.debug) {
                            return '<b style="color:red;">form field not found ' + BX.util.htmlspecialchars(ind) + '</b>';
                        }
                    }

                    let value = field.value;

                    if (value === null || value === undefined)
                        return '';

                    switch (field.type) {
                        case 'array':
                            if (Array.isArray(value))
                                value = value.join(', ');
                            break;
                        case 'date':
                            value = parseInt(value);
                            if (!isNaN(value)) {
                                value = (new Date(value * 1000)).toLocaleDateString();
                            } else value = '';

                            break;
                        case 'datetime':
                            value = parseInt(value);
                            if (!isNaN(value)) {
                                value = (new Date(value * 1000)).toLocaleString();
                            } else value = '';

                            break;
                        case 'time':
                            value = parseInt(value);
                            if (!isNaN(value)) {
                                let hours = Math.floor(value / (60 * 60)),
                                    minutes = Math.floor((value % (60 * 60)) / 60);

                                value = hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
                            } else value = '';

                            break;
                        case 'boolean':
                            value = value ? BX.message('DEVBX_WEB_FORM_FIELD_BOOLEAN_VALUE_TRUE') : BX.message('DEVBX_WEB_FORM_FIELD_BOOLEAN_VALUE_FALSE');
                            break;
                        case 'files':

                            let fileNames = [];

                            value.forEach(file => {
                                fileNames.push(file.name);
                            });

                            value = fileNames.join(', ');

                            break;
                    }

                    return BX.util.htmlspecialchars(value);
                });

                return html;
            },

            checkPageFields(forceCheck) {
                let result = [];

                this.activePageWebFormItems.forEach(item => {
                    if (!item.component)
                        return;

                    if (!forceCheck)
                    {
                        let field = item.component.field;

                        if (field && !field.changed)
                            return;
                    }

                    if (typeof item.component.checkErrors === 'function') {
                        if (item.component.checkErrors()) {
                            result.push(item.component);
                        }
                    }
                });

                return result;
            },

            showPrevPage() {
                this.setPageNumber(this.curPageNumber - 1);
            },

            showNextPage() {
                this.setPageNumber(this.curPageNumber + 1);
            },

            checkPageErrors(forceCheck, setFocus) {
                let errComponents = this.checkPageFields(forceCheck);

                if (!errComponents.length)
                    return false;

                errComponents.forEach(component => {
                    if (component.item) {
                        //fieldsErrors.push(component.item);
                    }
                });

                if (setFocus) {
                    errComponents[0].$el.scrollIntoView({behavior: "smooth"});
                    if (typeof errComponents[0].setFocus === 'function')
                        errComponents[0].setFocus();
                }

                return true;
            },

            getPageBusyMessages()
            {
                let result = [];

                this.activePageWebFormItems.forEach(item => {
                    if (!item.component)
                        return;

                    if (typeof item.component.getBusyMessage === 'function') {
                        result.push(...item.component.getBusyMessage());
                    }
                });

                return result;
            },

            showPageBusyMessages()
            {
                this.popupMessages = this.getPageBusyMessages();

                return this.popupMessages.length>0;
            },

            getFieldsByFieldId(systemId, children)
            {
                let result = [];

                if (!children)
                    children = this.formFields;

                children.forEach(field => {
                    if (field.fieldId !== systemId)
                        return;

                    if (field.type === 'object')
                    {
                        result.push(...this.getFieldsByFieldId(systemId, field.value));
                    } else {
                        result.push(field);
                    }
                });

                return result;
            },

            checkPageObjectErrors(page) {
                let hasErrors = false;

                page.getAllFormFields().every(obField => {
                    if (obField.config.showRule && this.checkCondition(obField, obField.config, 'showRule') === false)
                        return true;

                    if (obField.config.customError && this.checkCondition(obField, obField.config, 'showCustomError') === true)
                    {
                        hasErrors = true;
                        return false;
                    }

                    if (obField.config.requireRule && this.checkCondition(obField, obField.config, 'requireRule') === true)
                    {
                        let fields = this.getFieldsByFieldId(obField.config.systemId);

                        fields.forEach(field => {
                            if (field.virtual)
                                return;

                            if (typeof field.value === "number")
                                return; //ok

                            if (typeof field.value === "boolean" && field.value)
                                return; //ok

                            if (field.value === "undefined" || field.value === null || !field.value.length)
                                hasErrors = true; //not filled
                        });
                    }
                });

                return hasErrors;
            },

            setPageNumber(pageNum) {
                if (this.pageChange)
                    return;

                if (pageNum < 0 || pageNum >= Object.values(this.pages).length) {
                    console.error('invalid page number ' + pageNum);
                    return;
                }

                let curPageNum = this.curPageNumber;

                if (curPageNum === pageNum)
                    return;

                if (this.showPageBusyMessages())
                    return false;

                if (pageNum < curPageNum) {
                    this.activePageId = Object.values(this.pages)[pageNum].id;

                    this.visiblePages.splice(0, 0, Object.values(this.pages)[pageNum]);

                    let self = this;

                    setTimeout(function () {
                        self.visiblePages.splice(1, 1);
                    }, 0);

                    return;
                }

                if (this.checkPageErrors(true, true))
                    return;

                this.beforeTransitionCheckErrors = false;

                if (pageNum - curPageNum > 1) {

                    let hasErrors = false;

                    while (curPageNum < pageNum) {
                        curPageNum++;

                        let page = Object.values(this.pages)[curPageNum];

                        hasErrors = this.checkPageObjectErrors(page);

                        if (hasErrors) {
                            this.beforeTransitionCheckErrors = true;
                            break;
                        }

                        curPageNum++;
                    }

                    if (hasErrors)
                        pageNum = curPageNum;
                }

                this.activePageId = Object.values(this.pages)[pageNum].id;

                this.visiblePages.push(Object.values(this.pages)[pageNum]);
                this.visiblePages.splice(0, 1);
            },

            getObjectFieldTree(varName, fields) {
                let result = {},
                    prefix = varName.length ? varName+'.' : '';

                fields.forEach(field => {

                    if (field.type === 'object') {
                        Object.assign(result, this.getObjectFieldTree(prefix + field.name, field.value));
                    } else {
                        result[prefix + field.name] = field;
                    }
                });

                return result;
            },

            showFormError(message)
            {
                //conso
            },
        },
        computed: {
            pages() {
                let result = {};

                this.webForm.pages.items.forEach((page, index) => {
                    if (this.checkCondition(page, page.config, 'showPage') !== false) {
                        result[page.id] = page;
                    }
                });

                return result;
            },

            curPageNumber() {
                return Object.values(this.pages).indexOf(this.activePage);
            },

            activePage() {
                return this.pages[this.activePageId];
            },

            formFieldByName() {
                return this.getObjectFieldTree('Fields', this.formFields);
            },

            isPopup() {
                return this.formClass.indexOf('popup')>0;
            },

            activePageWebFormItems() {

                let result = [],
                    page = this.activePage;

                if (!page)
                    return result;

                return page.getAllFormFields();
            },

            webFormComponent()
            {
                return 'devbx-webform-mode-'+this.mode;
            },

            cssClass()
            {
                let result = {};

                if (this.webForm.settings.formCssClass.length)
                {
                    result[this.webForm.settings.formCssClass] = true;
                }

                return result;
            }
        },
        watch: {
            validation(val) {
                this.checkPageFields(true);
            },
        },
        template: `
        <div class="devbx-webform-clean-css">
            <component :class="cssClass" :is="webFormComponent"></component>
            
            <devbx-webform-popup-window v-if="errors.length" @close="errors = [];">
                <div class="devbx-webform-error" v-for="error in errors">
                    <span v-if="error.message">{{error.message}}</span>
                    <span v-else>{{error}}</span>                                
                </div>                            
            </devbx-webform-popup-window>
            
            <devbx-webform-popup-message v-if="popupMessages.length>0" :message="popupMessages[0]" @close="popupMessages=[]">
            
            </devbx-webform-popup-message>
        </div>
        `,
    });

    BX.onCustomEvent('DevBxWebFormCreated', [app]);

    return app;
}